import ContainerSkeleton from './ContainerSkeleton';

export default ContainerSkeleton;